"use client";

import { createContext, ReactNode, useState } from 'react';
import ShortsNavigator_fullscreen from './ShortsNavigator_fullscreen';

// Create a context
export const ShortsNavigatorContext = createContext({
    isOpen: false, setIsOpen: (state: boolean) => { },
    currentVideo: "", setCurrentVideo: (videoID: string) => { }
});

// Create a provider component
export default function ShortsNavigator_client({ children, videoIdList }: { children: ReactNode, videoIdList: string[] }) {
    const [isOpen, setIsOpen] = useState(false);
    const [currentVideo, setCurrentVideo] = useState(videoIdList[0]);

    return (
        <ShortsNavigatorContext.Provider value={ { isOpen, setIsOpen, currentVideo, setCurrentVideo } }>
            { children }

            { isOpen &&
                <ShortsNavigator_fullscreen videoIdList={ videoIdList } />
            }
        </ShortsNavigatorContext.Provider>
    );
};
